<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="surgery-list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            :columnConfig="true"
            :tableHeight="tableHeight"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :fuzzySearch="true"
            @loadAnesthesiaIndex="loadAnesthesiaIndex"
            @loadMergedPatientData="loadMergedPatientData"
            @loadReoperation="loadReoperation"
            @loadRestartOperation="loadRestartOperation"
            @print="print"
        >
            <template slot="filter">
                <el-col :md="8" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input
                        type="string"
                        class="margin5 margin-none-h"
                        v-model="searchKey2"
                        :placeholder="getPlaceholder"
                        :autofocus="true"
                        :clearable="true"
                        @keyup.native.enter="loadSurgeries2"
                    ></item-input>
                </el-col>
                <el-col :md="8" :lg="5" :xl="5">
                    <item-input type="multiselect" v-model="surgery_status" :options="sys_enums && sys_enums.SurgeryStatus" :clearable="true" placeholder="手术状态"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="dic_room_id" :options="operationRoom" :clearable="true" placeholder="检查室"></item-input>
                </el-col>
                <el-col :span="4"> &nbsp;<item-input type="checkbox" v-model="is_own" style="display: inline-block; width: 50px">我的患者</item-input> </el-col>
            </template>
            <span slot="push_status" slot-scope="{ row }">
                <i v-if="row.push_status == 1" class="el-icon-circle-check fg-primary"> </i>
                <i v-else-if="row.push_status == 2" class="el-icon-circle-check-outline fg-warning" :title="row.push_status_msg"></i>
                <i v-else-if="row.push_status == 3" class="el-icon-circle-close fg-danger" :title="row.push_status_msg"></i>
                <i v-else> </i>
            </span>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="refreshList" title="查询">查询<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="loadOperationRoom" v-if="isDesktop">创建急诊检查</el-button>
            </template>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            :title="row.surgery_status"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left">
                        <div class="fg-info ellipsis" :title="`${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)`">
                            <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                            {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)` }}
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div>
                            <el-tag
                                :style="{ color: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C', borderColor: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C', backgroundColor: 'white' }"
                                size="mini"
                                >{{ row.surgery_type }}</el-tag
                            >
                            <!-- <el-tag style="color: #f56c6c; border-color: #f56c6c; background-color: white" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag> -->
                            <el-tag
                                :style="{ color: row.enum_surgery_status >= 40 ? '#DFE2E7' : '#52b8d2', borderColor: row.enum_surgery_status == 40 ? '#DFE2E7' : '#52b8d2', backgroundColor: 'white' }"
                                size="mini"
                                >{{ row.enum_surgery_status > 10 ? '已排' : '待排' }}</el-tag
                            >
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white" size="mini">{{
                                row.enum_visit_type == 1 ? '住院' : row.enum_visit_type == 2 ? '门诊' : '体检'
                            }}</el-tag>
                            <el-tag :style="{ color: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', borderColor: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', backgroundColor: 'white' }" size="mini"
                                >日间</el-tag
                            >
                            <el-tag :style="{ color: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', borderColor: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', backgroundColor: 'white' }" size="mini"
                                >内镜</el-tag
                            >
                        </div>
                    </el-col>
                </el-row>
            </template>
            <template slot="diseases" slot-scope="{ row }">
                <div style="width: 180px; white-space: normal">
                    <span>{{ row.diseases }}</span>
                </div>
            </template>
            <template slot="surgeon" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    (主)<span>{{ row.surgeon }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
            </template>
            <template slot="plan_anes_doctor" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    (主)<span>{{ row.plan_anes_doctor }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.plan_anes_assistants && row.plan_anes_assistants.toString() }}</span>
                </div>
            </template>
            <template slot="anaes_methods" slot-scope="{ row }"
                ><div style="width: 100px; white-space: normal" :style="row.anaes_methods_color != '' ? 'background-color:rgb(' + row.anaes_methods_color + ')' : ''">
                    <span>{{ row.anaes_methods }}</span>
                </div></template
            >
            <template slot="dic_section" slot-scope="{ row }"
                ><div style="width: 100px; white-space: normal">
                    <span>{{ row.dic_section }}</span>
                </div></template
            >
            <template slot="plan_circuit_nurse" slot-scope="{ row }"
                ><div style="{{}}row. width: 60px; white-space: normal">
                    <span>{{ row.plan_circuit_nurse && row.plan_circuit_nurse.toString() }}</span>
                </div></template
            >
            <template slot="plan_equipment_nurse" slot-scope="{ row }"
                ><div style="width: 60px; white-space: normal">
                    <span>{{ row.plan_equipment_nurse && row.plan_equipment_nurse.toString() }}</span>
                </div></template
            >
        </crud-facecade>

        <form-dialog
            title="选择检查室"
            :visible.sync="emergencySurgery.emergencySurgeryVisible"
            :data="emergencySurgery.data"
            :columns="emgrgencySurgeryList2"
            width="30%"
            @confirm="SaveEmgrgencySurgery"
        ></form-dialog>
        <form-dialog
            title="选择检查室"
            :visible.sync="RreoperationView.dialogFormVisible"
            :data="RreoperationView.data"
            :columns="emgrgencySurgeryList"
            width="30%"
            @confirm="reOperation"
        ></form-dialog>
        <form-dialog
            title="选择检查室"
            :visible.sync="RestartOperationView.dialogFormVisible"
            :data="RestartOperationView.data"
            :columns="emgrgencySurgeryList"
            width="30%"
            @confirm="RestartOperation"
        ></form-dialog>
        <form-dialog
            title="选择记录单"
            :visible.sync="LoadOperationView.dialogFormVisible"
            :data="LoadOperationView.data"
            :columns="emgrgencyRecordList"
            width="30%"
            @confirm="LoadOperation"
        ></form-dialog>
        <form-dialog
            title="选择记录单"
            :visible.sync="RLoadOperationView.dialogFormVisible"
            :data="RLoadOperationView.data"
            :columns="emgrgencyRecordList"
            width="30%"
            @confirm="RLoadOperation"
        ></form-dialog>
        <el-dialog title="合并检查" :visible.sync="mergeApplyList.dialogFormVisible" class="table-h460" :close-on-click-modal="false" width="90%">
            <crud-facecade
                ref="merge-list"
                :url="mergeApplyList.data"
                :columns="mergeColunmList"
                :buttons="buttons"
                :addButton="{ enabled: false }"
                :updateButton="{ enabled: false }"
                @rowClick="activTargetRow"
            >
                <template slot="filter">
                    <el-col :span="4">
                        <item-input type="datearraw2" v-model="rdate1" :clearable="false" size="mini"></item-input>
                    </el-col>
                </template>
                <div slot="table-title" class="align-left padding5" v-show="mergedRow !== undefined">
                    <b>患者姓名:</b> {{ mergedRow && mergedRow.patient_name }} &nbsp; <b>病历号:</b>{{ mergedRow && mergedRow.visit_no }} &nbsp; <b>性别:</b>{{ mergedRow && mergedRow.sex }} &nbsp;
                    <b>年龄:</b>{{ mergedRow && mergedRow.age }} &nbsp; <b>科室:</b>{{ mergedRow && mergedRow.dic_section }} &nbsp; <b>拟施手术:</b>{{ mergedRow && mergedRow.surgeries }} &nbsp;
                </div>
            </crud-facecade>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelMerge">取 消</el-button>
                <el-button type="primary" @click="merged">确 定</el-button>
            </span>
        </el-dialog>
        <pdf-frame :base64="base64" :visible.sync="pdfvisible" title="麻醉记录单"></pdf-frame>
    </div>
</template>
<script>
import Json5 from 'json5'
import printJs from 'print-js'
import { mapGetters } from 'vuex'
export default {
    name: `SurgeryEndoscopy`,
    props: {},
    data() {
        // 监听页面回传消息
        window.addEventListener(
            `message`,
            event => {
                let d = (_.startsWith(event.data, `{`) && Json5.parse(event.data)) || {}
                if (d.order == `refreshAnesList`) {
                    this.$refs[`surgery-list`].ReloadListData()
                }
            },
            false
        )
        return {
            title: `内镜检查`,
            surgeryinfopush: this.$root.SurgeryInfoPush,
            url: {
                area: `SurgeryEndoscopyList`,
                baseURL: `/api`,
                get: paras => {
                    return this.ReloadListData()
                }
            },
            buttons: [],
            enable_tagsview: true,
            activeSurgeryId: this.$route.query.surgery_id,
            activeNames: [],
            isReloadAlive: true,
            searchKey: ``,
            searchKey2: ``,
            surgeries: [],
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            rdate1: this.$moment().format(`YYYY/MM/DD`),
            rowClass: {},
            dic_room_id: undefined,
            surgery_status: [20, 30, 40, 50, 60], // 20
            is_own: false,
            emergencySurgery: {
                emergencySurgeryVisible: false,
                data: {}
            },
            mergeApplyList: {
                dialogFormVisible: false,
                data: {
                    baseURL: `/api/Preoperative/Apply/GetForMergeList`,
                    get: () => {
                        return new Promise((resolve, reject) => {
                            let that = this
                            let req = that.myaxios.get(`/api/Preoperative/Apply/GetForMergeList?date=${this.rdate1}`)
                            req.then(data => {
                                resolve(data)
                            }).catch(e => reject(e))
                        })
                    }
                }
            },
            mergedRow: undefined,
            merged_target_row: undefined,
            reoperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, operatingRoomId: `` }
            },
            RestartOperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, operatingRoomId: `` }
            },
            LoadOperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, in_room_time: ``, lable: `` }
            },
            RLoadOperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, in_room_time: ``, lable: `` }
            },
            base64: ``,
            pdfvisible: false,
            RecordConfig: [],
            Aconfig: ``,
            is_local_anes: null,
            RreoperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, in_room_time: `` }
            }
        }
    },
    created() {
        let that = this
        // this.$store.dispatch("ADD_OPERATION_WARD_AUTH")
        this.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(() => {
            that.loadWorkStationConfig().then(() => {
                that.ReloadListData()
            })
        })
    },

    computed: {
        ...mapGetters([`operation_room_auth`, `operation_ward_auth`, `sys_enums`, `active_ward`, `screenHeight`, `business`, `localip/ipAddress`,
            `otherSettingColumn`,
            `extendColumnList`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 160) || 0
        },
        getPlaceholder() {
            return `请扫${this.T(`surgery.visit_no`)}`
        },
        isDesktop() {
            return typeof winformMsg != `undefined`
        },
        localIp() {
            return (this[`localip/ipAddress`][0] && this[`localip/ipAddress`][0].value) || `0.0.0.0`
        },
        columnList() {
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息`,
                    width: `260`,
                    isListable: true
                }, {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    width: `80`,
                    isListable: true,
                    options: this.sys_enums.VisitType || []
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: `enum_bool`
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `100`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `surgery_status`,
                    label: `患者状态`,
                    width: `80`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`surgery_endoscopy.visit_no`),
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `检查室`,
                    width: `120`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sequence`,
                    label: `台次`,
                    width: `60`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    width: `60`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `anaes_methods`,
                    label: `计划麻醉方式`,
                    width: `100`,
                    color: `red`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `预约检查时间`,
                    width: `140`,
                    sortable: `desc`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `160`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: (that, { row }) => {
                        let r = [
                            {
                                class: `is-plain is-circle`,
                                label: ``,
                                icon: `el-icon-document`,
                                type: `primary`,
                                emit: `loadAnesthesiaIndex`,
                                permission: `default`,
                                tooltip: `无痛内镜检查记录单`
                            }
                        ]
                        if (row.enum_surgery_status == 40 || row.enum_surgery_status == 60) {
                            if (row.enum_surgery_type == 1) {
                                r.push({
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-folder-checked`,
                                    type: `primary`,
                                    emit: `loadMergedPatientData`,
                                    permission: `default`,
                                    tooltip: `检查合并`
                                })
                            }
                            if (this.isDesktop === false) {
                                r.push({
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-printer`,
                                    type: `primary`,
                                    emit: `print`,
                                    permission: `default`,
                                    tooltip: `打印`
                                })
                            }
                        }
                        return r
                    },
                    config: {
                        align: `flex-start`
                    }
                }
            ]
            if (this.surgeryinfopush == `true`) {
                list.push({
                    type: `custom`,
                    prop: `push_status`,
                    label: `回传状态`,
                    width: `120`,
                    isListable: true
                })
            }
            // 显示动态扩展列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)
            console.log(list)
            return list
        },
        operationRoom() {
            return (
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            )
        },
        anesthesia_path() {
            let r = _.find(this.business, { business_level: `M002` })
            return (r && r.url) || `/`
        },
        emgrgencySurgeryList() {
            let list =
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            return [
                {
                    type: `select`,
                    prop: `JH`,
                    label: `检查室`,
                    options: list,
                    colspan: 24,
                    size: ``,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `reason`,
                    label: `原因`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        },
        emgrgencySurgeryList2() {
            let list =
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            return [
                {
                    type: `select`,
                    prop: `JH`,
                    label: `检查室`,
                    options: list,
                    colspan: 24,
                    size: ``,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        },
        emgrgencyRecordList() {
            return [
                {
                    type: `select`,
                    prop: `JLD`,
                    label: `记录单`,
                    options: this.RecordConfig,
                    colspan: 24,
                    size: ``,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        },
        mergeColunmList() {
            return [
                {
                    type: `string`,
                    label: `序号`,
                    prop: `id`,
                    isListable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    label: this.T(`surgery_endoscopy.visit_no`),
                    prop: `visit_no`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `姓名`,
                    prop: `patient_name`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `性别`,
                    prop: `sex`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `年龄`,
                    prop: `age`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `科室`,
                    prop: `dic_section`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `拟施手术`,
                    prop: `surgeries`,
                    isListable: true
                }
            ]
        }
    },
    methods: {
        print({ row }) {
            let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${row.id}&recordType=1`)
            req.then(data => {
                printJs({ printable: data, type: `pdf`, base64: true })
            }).catch(e => console.log(e))
        },
        ReloadListData() {
            let that = this
            // 更改日期触发更新列表
            let operatingWardId = 0
            let operatingRoomId = 0
            let recoveryWardId = 0

            if (that.active_ward && _.startsWith(that.active_ward.value, `ow_`)) {
                operatingWardId = that.active_ward.origion || 0
                operatingRoomId = that.dic_room_id || 0
                recoveryWardId = 0
            }
            // 选复苏室则只看在当前复苏室的患者
            if (that.active_ward && _.startsWith(that.active_ward.value, `rw_`)) {
                operatingWardId = 0
                operatingRoomId = 0
                recoveryWardId = that.active_ward.origion || 0
            }

            return new Promise(resolve => {
                let req = this.myaxios.post(
                    `/api/Operation/Home/GetSurgeryList`,
                    {
                        begin: that.rdate[0],
                        end: that.$moment(that.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`),
                        surgery_status: that.surgery_status,
                        dic_operating_ward_id: operatingWardId,
                        dic_operating_room_id: operatingRoomId,
                        dic_recovery_ward_id: recoveryWardId
                    }
                )
                req.then(data => {
                    data = _.filter(data, { is_endoscopy: true })
                    let sk = this.searchKey.toUpperCase()
                    if (sk.length > 0) {
                        // ACIS-19803 验证手术
                        let patient = _.find(data, d => {
                            return d.visit_no && d.visit_no.toUpperCase() == sk
                        })
                        if (patient && patient.dic_operating_room_id !== this.dic_room_id) {
                            this.$alert(`<strong>非本检查室患者</strong>`, `核对失败`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                            return
                        }
                        if (patient) {
                            if (!(patient.plan_time && this.$moment(patient.plan_time).format(`YYYYMMDD`) == this.$moment().format(`YYYYMMDD`))) {
                                this.$alert(`<strong>非今日排程检查患者！</strong>`, `核对失败`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                            } else {
                                if (this.dic_room_id && patient.dic_operating_room_id !== this.dic_room_id) {
                                    this.$alert(`<strong>非本检查室今日排程检查患者！</strong>`, `核对失败`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    })
                                } else if (`ow_${patient.dic_operating_ward_id}` !== this.active_ward.value) {
                                    this.$alert(`<strong>非本检查区今日排程检查患者！</strong>`, `核对失败`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    })
                                } else {
                                    this.searchKey2 = ``
                                    this.$alert(
                                        `
                    <div>
                    <div>
                        <span>姓名：${patient.patient_name}</span>&nbsp;&nbsp;
                        <span>${this.T(`surgery_endoscopy.visit_no`)}：${patient.visit_no}</span>&nbsp;&nbsp;
                        <span>性别：${patient.sex || `--`}</span>&nbsp;&nbsp;
                        <span>年龄：${patient.age || `--`}</span>
                    </div>
                    <div>科室：${patient.dic_section || `--`}</div>
                    <div>检查医生：${patient.surgeon || `--`}</div>
                    <div>检查部位：${``}</div>
                    <div>术式：${patient.surgeries || `--`}</div>
                    <div>检查室：${patient.dic_operating_room || `--`}</>
                    <div>麻醉医生：${patient.anes_doctor || `--`}</div>
                    <div>麻醉方法：${patient.anaes_methods || `--`}</div>
                    </div>
                                `,
                                        `核对成功`,
                                        {
                                            dangerouslyUseHTMLString: true,
                                            callback: action => {
                                                this.loadAnesthesiaIndex({ row: { id: patient.id } })
                                            }
                                        }
                                    )
                                }
                            }
                        } else {
                            this.$message.warning(`暂无该患者信息`)
                        }
                    }

                    let r = _.filter(data, d => {
                        // let  sk = this.searchKey.toUpperCase()
                        let result = true

                        if (result && this.is_own) {
                            result = d.is_own_data_auth_filter
                        }
                        if (result && sk.length > 0) {
                            // result = d.patient_abbr.toUpperCase().indexOf(sk)>-1||d.patient_name.toUpperCase().indexOf(sk)>-1||d.visit_no.toUpperCase().indexOf(sk)>-1
                            result = d.visit_no && d.visit_no.toUpperCase() == sk
                        }
                        return result
                    }).map(d => {
                        d.plan_anes_doctor = d.plan_anes_doctor && d.plan_anes_doctor.label
                        d.plan_anes_assistants = d.plan_anes_assistants && d.plan_anes_assistants.length > 0 && d.plan_anes_assistants.map(i => i.label).join(`,`)
                        d.plan_circuit_nurse = d.plan_circuit_nurse && d.plan_circuit_nurse.length > 0 && d.plan_circuit_nurse.map(i => i.label).join(`,`)
                        d.plan_equipment_nurse = d.plan_equipment_nurse && d.plan_equipment_nurse.length > 0 && d.plan_equipment_nurse.map(i => i.label).join(`,`)
                        // added by xiaorui ACIS-22657,当配置显示动态列时,每行数据动态的装载列
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                        return d
                    })
                    // let res = _.orderBy(r, ['dic_operating_room_id', 'plan_time'], ['asc', 'desc'])
                    // r = _.orderBy(r, ['dic_operating_room_id'], ['asc'])
                    console.log(r)
                    resolve(r)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        loadAnesthesiaIndex({ row }) {
            let that = this
            // 处理选择记录单弹框
            this.LoadOperationView.data = {
                surgeryInfoId: row.id,
                in_room_time: row.in_room_time
            }

            this.Data(row).then(data => {
                if (data == true) {
                    // eslint-disable-next-line no-undef
                    this.$message(`该手术为局麻手术，请在局麻手术中操作`)
                    return
                }

                if (this.Aconfig == `1` && row.in_room_time == null) {
                    this.LoadOperationView.dialogFormVisible = true
                } else {
                    console.log(`Aconfig`, row)
                    let req = this.myaxios.get(`/api/AcisSystem/OperatingWard/Get?id=${row.dic_operating_ward_id}`)
                    this.myaxios
                        .all(req)
                        .then(([data]) => {
                            if (data && data.allow_select_record_template && row.in_room_time == null) {
                                that.Aconfig = `1`
                                that.LoadOperationView.dialogFormVisible = true
                            } else {
                                that.Aconfig = `0`
                                that.LoadOperation(row)
                            }
                        })
                        .catch(e => {
                            console.log(e)
                        })
                    this.LoadOperation(row)
                }
            })
        },
        Data(row) {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Apply/Get?id=${row.id}`)
                this.myaxios
                    .all(req)
                    .then(([data]) => {
                        resolve(data.is_local_anes)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        LoadOperation(row) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `openAnes`,
                    id: row.surgeryInfoId || row.id
                }
                winformMsg.acceptMessage(cefJson)
            } else {
                let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${row.surgeryInfoId || row.id}&recordType=1`)
                req.then(data => {
                    this.pdfvisible = true
                    this.base64 = data
                }).catch(e => console.log(e))
            }
            this.LoadOperationView.dialogFormVisible = false
            // 创建需要的麻醉单
            if (row.in_room_time == null && row.JLD != null) {
                this.myaxios.post(
                    `/api/AcisSystem/RecordConfig/CreateSurgeryInfoMapRecord?surgeryInfoId=${row.surgeryInfoId || row.id}&FileName=${_.filter(this.RecordConfig, { value: row.JLD })[0].label}`
                )
            }
        },
        refreshList() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        loadOperationRoom() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                this.emergencySurgery.emergencySurgeryVisible = true
            } else {
                this.$message(`网页端不允许创建急诊检查`, `warning`)
            }
        },
        SaveEmgrgencySurgery(row) {
            let dicOperatingWardId = this.active_ward && this.active_ward.value
            let data = {
                dic_operating_ward_id: dicOperatingWardId.substr(dicOperatingWardId.indexOf(`_`) + 1),
                dic_operating_room_id: row.JH
            }
            let req = this.myaxios.post(`/api/Preoperative/Apply/PostEmergency`, data)
            req.then(data => {
                let row = { id: data }
                this.loadAnesthesiaIndex({ row })
                this.emergencySurgery.emergencySurgeryVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        loadMergedPatientData({ row }) {
            this.mergedRow = { ...row }
            // if(this.mergedRow === undefined){
            //   this.$message.warning('未选中需要合并的患者')
            //   return
            // }
            // if(this.mergedRow.enum_surgery_type!==1||(this.mergedRow.enum_surgery_status!==40&&this.mergedRow.enum_surgery_status!==60)){
            //   this.$message.warning('只能合并手术结束或苏醒结束的急诊手术')
            //   return
            // }
            // this.$refs["merge-list"].ReloadListData()
            this.mergeApplyList.dialogFormVisible = true
        },
        activTargetRow({ row }) {
            this.merged_target_row = row
        },
        merged() {
            let surgeryDone = this.mergedRow && this.mergedRow.id
            let hisSurgeryId = this.merged_target_row && this.merged_target_row.id
            let that = this
            this.$confirm(`确定弹出合并信息？合并后将无法撤销`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                if (surgeryDone === undefined || hisSurgeryId === undefined) {
                    that.$message.warning(`未选择需要合并的患者`)
                    return
                }
                let req = that.myaxios.post(`/api/Preoperative/Apply/MergeSurgery?surgeryDone=${surgeryDone}&hisSurgeryId=${hisSurgeryId}`)
                req.then(data => {
                    this.$refs[`surgery-list`].ReloadListData()
                    that.mergeApplyList.dialogFormVisible = false
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        cancelMerge() {
            this.mergeApplyList.dialogFormVisible = false
        },
        loadSurgeries2() {
            this.searchKey = this.searchKey2
            // this.$refs["surgery-list"].ReloadListData()
        },
        loadWorkStationConfig() {
            if (!this[`localip/ipAddress`]) return
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${this[`localip/ipAddress`]}`)
                let req1 = this.myaxios.get(`/api/AcisSystem/RecordConfig/GetByType?intType=${1}`)
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=AllowSelectRecordTemplate`)
                this.myaxios.all(req, req1, req2).then(([data, data1, data2]) => {
                    let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${data && data.dic_operating_room_id || 0}`)
                    req1.then(d => {
                        let operatingWardId = d && d.dic_operating_ward_id || null
                        let activeWardId = this.active_ward && this.active_ward.origion || null
                        // 工作站设置的手术区和当前手术区是否相等，相等取工作站设置的手术间id,不同取当前手术区手术间列表第一个
                        if (operatingWardId && operatingWardId > 0 && operatingWardId == activeWardId) {
                            this.dic_room_id = (data && data.dic_operating_room_id)
                        }
                        resolve()
                    }).catch(e => {
                        console.log(e)
                    })

                    let list = _.map(data1, d => {
                        return {
                            value: d.id,
                            label: d.file_name,
                            is_delete: d.is_delete
                        }
                    })
                    this.RecordConfig = _.filter(list, { is_delete: false })
                    this.Aconfig = data2.value
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadReoperation({ row }) {
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `患者“${row.patient_name}”“${row.visit_no}”,是否需要再次检查？`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.RreoperationView.data = {
                        surgeryInfoId: row.id,
                        in_room_time: row.in_room_time
                    }
                    this.RreoperationView.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        reOperation(row) {
            this.RreoperationView.dialogFormVisible = false
            if (this.Aconfig == `1`) {
                this.RLoadOperationView.data = {
                    surgeryInfoId: row.id | row.surgeryInfoId,
                    in_room_time: row.in_room_time,
                    JH: row.JH,
                    reason: row.reason
                }
                this.RLoadOperationView.dialogFormVisible = true
            } else {
                this.RRLoadOperation(row)
            }
        },
        RLoadOperation(row) {
            let req = this.myaxios.put(
                `api/Intraoperative/Anaesthesia/Reoperation_fileName?surgeryInfoId=${row.surgeryInfoId}&&operatingRoomId=${row.JH}&&reason=${row.reason}&&FileName=${
                    _.filter(this.RecordConfig, { value: row.JLD })[0].label
                }`
            )
            req.then(() => {
                this.$refs[`surgery-list`].ReloadListData()
                this.RLoadOperationView.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        RRLoadOperation(row) {
            let req = this.myaxios.put(`api/Intraoperative/Anaesthesia/Reoperation_fileName?surgeryInfoId=${row.surgeryInfoId}&&operatingRoomId=${row.JH}&&reason=${row.reason}&&FileName=${``}`)
            req.then(() => {
                this.$refs[`surgery-list`].ReloadListData()
                this.RLoadOperationView.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        loadRestartOperation({ row }) {
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `患者“${row.patient_name}”“${row.visit_no}”,是否需要重新检查？`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.RestartOperationView.data = {
                        surgeryInfoId: row.id | row.surgeryInfoId
                    }
                    this.RestartOperationView.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        RestartOperation(row) {
            let req = this.myaxios.put(`api/Intraoperative/Anaesthesia/RestartOperation?surgeryInfoId=${row.surgeryInfoId}&&operatingRoomId=${row.JH}&&reason=${row.reason}`)
            req.then(() => {
                this.$refs[`surgery-list`].ReloadListData()
                this.RestartOperationView.dialogFormVisible = false
            }).catch(e => console.log(e))
        }
    },
    watch: {
        searchKey2: function(newVal, oldVal) {
            if (newVal.length == 0) {
                this.searchKey = newVal
            }
        },
        rdate1: function(newVal, oldVal) {
            this.$refs[`merge-list`].ReloadListData()
        },
        active_ward: function() {
            this.dic_room_id = this.active_ward.operation_room && this.active_ward.operation_room.length > 0 && this.active_ward.operation_room[0].value || null
            this.$refs[`surgery-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/SurgeryEndoscopy.vue